import { type NoteEditorType } from '@/models/analytics/features/notes';
import { createContext, useContext } from 'react';

export type EditorAnalytics = { editorType?: NoteEditorType };

/**
 * Supplies the host editor variant to the shared bubble-menu building blocks so
 * every auto-instrumented `button_clicked` is segmentable by editor
 * (`editor_type`). Each editor container provides its own value; the shared
 * buttons read it via `useEditorAnalytics` without prop-drilling through the
 * floating-menu portal (React context follows the tree, not the DOM). Precedent:
 * the per-twin `useSectionEditorContext` used by the section node-view.
 *
 * Context and hook live here rather than beside the provider component so the
 * provider's `.tsx` exports components only (Fast Refresh ratchet).
 */
export const EditorAnalyticsContext = createContext<EditorAnalytics>({});

/** The surrounding editor's analytics context for shared menu buttons. */
export function useEditorAnalytics(): EditorAnalytics {
  return useContext(EditorAnalyticsContext);
}
